
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';

import {
    activityPersonalPKRankingList,
    activityPersonalPKRankingEntrancePosterImgSortDescEdit,
    activityPersonalPKRankingEntrancePosterImgIsShowEdit,
    activityPersonalPKRankingDelete,
    activityPersonalPKRankingRewardMoneyList,
    activityPersonalPKRankingShareList
} from '@/api/toBApi';
import {
    productpopoverproductlist
} from '@/api/supplier';
import {
    getMenuPermission
} from '@/api/user';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-dialog': Dialog,
    }
})
export default class ProductRecommend extends Vue {

    private list = [];
    private keywords = '';
    private state = null;
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private permission = [];
    private showControlsColumn = false;

    private stateList = [
        { value: null, label: '全部' },
        { value: 0, label: '未开始' },
        { value: 1, label: '进行中' },
        { value: 2, label: '已结束' }
    ];


    private bonusDetails = {
        show: false,
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0,
        keywords: '',
        id: '',
        details: {}
    }

    private shareDetails = {
        show: false,
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0,
        keywords: '',
        id: '',
        details: {}
    }

    private mounted() {
        this.getRole();
        this.doSearch();
    }

    private async getRole() {
        let res: any = await getMenuPermission({});
        let keys = [];
        if (res.IsSuccess) {
            res.Result.map((item: any) => {
                if (item.Sref === 'toBApp') {
                    item.EmployeeRoleChildMenuList.map((obj: any) => {
                        if (obj.Sref === 'soloRanking'){
                            obj.EmployeeRoleChildMenuList.map((obj1: any) => {
                                keys.push(obj1.Sref);
                            })  
                        }
                    })
                }
            })
            this.permission = keys;

            // let array1 = ['soloRankingBonusDetails', 'soloRankingBonusRecords', 'soloRankingShareDetails', 'soloRankingDelete'];
            // this.showDropdown = keys.some(item => array1.includes(item));
            // console.log(this.showDropdown);


            let array2 = ['soloRankingEdit', 'soloRankingShowOrHiddenActivity', 'soloRankingBonusDetails', 'soloRankingBonusRecords', 'soloRankingShareDetails', 'soloRankingDelete', 'soloRankingAdd'];
            this.showControlsColumn = keys.some(item => array2.includes(item));

        }
    }

    private showDropdown(record){
        if (this.permission.includes('soloRankingBonusDetails')) return true;
        if (this.permission.includes('soloRankingBonusRecords')) return true;
        if (record.PKMetricType === 5 && this.permission.includes('soloRankingShareDetails')) return true;
        if (this.permission.includes('soloRankingDelete')) return true;
        if (this.permission.includes('soloRankingAdd')) return true;
        return false;
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                Keywords: this.keywords.trim(),
                State: this.state,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await activityPersonalPKRankingList(params);
            this.list = res.Result.Results.map(item => {
                item.visible1 = false;
                item.showIcon2 = false;
                item.SortDescCopy = item.EntrancePosterImgSortDesc;
                return item;
            });
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private handleEdit(record: any = {}) {
        this.$router.push({
            name: 'soloRankingDetails',
            query: {
                id: record.Id || ''
            }
        })
    }

    private cellMouseEnter(row) {
        row.showIcon2 = true;
    }
    private cellMouseLeave(row) {
        console.log(row.visible1)
        if (!row.visible1) {
            row.showIcon2 = false;
        }
    }
    private async handleSaveSort(record) {

        let sort = record.SortDescCopy + '';
        let sortNum = +sort;
        if (isNaN(sortNum) || sortNum < 0 || sortNum > 99999) {
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }
        if (sort.indexOf('.') > -1) {
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }

        try {
            await activityPersonalPKRankingEntrancePosterImgSortDescEdit({ ActivityPersonalPKRankingId: record.Id, EntrancePosterImgSortDesc: record.SortDescCopy });
            this.$message.success('操作成功');
            record.visible1 = false;
            record.showIcon2 = false;
            this.doSearch();
        } catch (error) {

        } finally {
        }
    }

    private async handleIsShowChange(record) {
        this.loading = true;
        try {
            await activityPersonalPKRankingEntrancePosterImgIsShowEdit({ ActivityPersonalPKRankingId: record.Id, EntrancePosterImgIsShow: !record.EntrancePosterImgIsShow });
            this.$message.success('操作成功');
            this.doSearch();
        } catch (error) {

        } finally {
            this.loading = false;
        }
    }
    private handleToDelete(record) {
        this.$confirm('是否确认删除PK榜活动【' + record.Name + '】？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            try {
                await activityPersonalPKRankingDelete({ ActivityPersonalPKRankingId: record.Id });
                this.$message.success('操作成功');
                this.doSearch();
            } catch (error) {

            } finally {

            }
        }).catch(() => {
        });
    }

    private handleClickDropdown(e, record) {
        if (e === '4') {
            this.handleToDelete(record);
        } else if (e === '1') {
            this.bonusDetails.show = true;
            this.bonusDetails.keywords = '';
            this.bonusDetails.id = record.Id;
            this.handleBonusDetailsPopSearch();
        } else if (e === '2') {
            this.$router.push({
                name: 'soloRankingRecords',
                query: {
                    id: record.Id || '',
                    name: record.Name || ''
                }
            })
        } else if (e === '3') {
            this.shareDetails.show = true;
            this.shareDetails.keywords = '';
            this.shareDetails.id = record.Id;
            this.handleShareDetailsPopSearch();
        } else if (e === '5') {

            let query: any = {
                id: record.Id || '',
                copy: 1
            }

            this.$router.push({
                name: 'soloRankingDetails',
                query: query
            })
        }
    }


    //奖金明细
    private handleBonusDetailsPopSearch() {
        this.bonusDetails.pageNo = 1;
        this.getBonusDetails();
    }
    private bonusDetailsChangePage(e) {
        this.bonusDetails.pageNo = e;
        this.getBonusDetails();
    }
    private async getBonusDetails() {
        try {
            let params: any = {
                Skip: (this.bonusDetails.pageNo - 1) * this.bonusDetails.pageSize,
                Take: this.bonusDetails.pageSize,
                Keywords: this.bonusDetails.keywords.trim(),
                ActivityPersonalPKRankingId: this.bonusDetails.id,
            }
            const res: any = await activityPersonalPKRankingRewardMoneyList(params);
            let obj = res.Result;
            this.bonusDetails.total = obj.ActivityPersonalPKRankingRewardMoneyDtos.Total;
            this.bonusDetails.list = obj.ActivityPersonalPKRankingRewardMoneyDtos.Results;
            this.bonusDetails.details = obj;
        } catch (e) {

        }
    }
    private handleExportBonusDetails() {
        const url = `${location.origin}/pc/activityPersonalPKRanking/rewardMoneyList?Keywords=${this.bonusDetails.keywords.trim()}&ActivityPersonalPKRankingId=${this.bonusDetails.id}`;
        window.open(url);
    }


    //分享明细
    private handleShareDetailsPopSearch() {
        this.shareDetails.pageNo = 1;
        this.getShareDetails();
    }
    private shareDetailsChangePage(e) {
        this.shareDetails.pageNo = e;
        this.getShareDetails();
    }
    private async getShareDetails() {
        try {
            let params: any = {
                Skip: (this.shareDetails.pageNo - 1) * this.shareDetails.pageSize,
                Take: this.shareDetails.pageSize,
                Keywords: this.shareDetails.keywords.trim(),
                ActivityPersonalPKRankingId: this.shareDetails.id,
            }
            const res: any = await activityPersonalPKRankingShareList(params);
            let obj = res.Result;
            this.shareDetails.total = obj.ActivityPersonalPKRankingShareDtos.Total;
            this.shareDetails.list = obj.ActivityPersonalPKRankingShareDtos.Results;
            this.shareDetails.details = obj;
        } catch (e) {

        }
    }
    private handleExportShareDetails() {
        let url = location.origin + '/pc/activityPersonalPKRanking/shareList';
        url += '?ActivityPersonalPKRankingId=' + this.shareDetails.id;
        url += '&Keywords=' + this.shareDetails.keywords.trim();
        window.open(url)
    }
}
